import React, { useEffect } from 'react'
import { ModalContext } from '@hooks/use-modal'
//import { Modal } from '@ui/components/modal.component'
import {type OverlayTriggerProps, useOverlayTriggerState } from 'react-stately'
import { useOverlayTrigger } from 'react-aria'
//import { FileUploadComponent } from '@ui/stepper/steps/richiesta/components/modal-views/file-upload.component.tsx'
//import { ModalSummaryComponent } from '@ui/components/fiscal-summary'
import { useAppContext } from '@hooks/use-app-context.ts'
import { Actions } from '@store/reducer.ts'
//import { QRScanComponent } from '@ui/stepper/steps/richiesta/components/modal-views/mobile-upload.component.tsx'
//import { DocumentazioneModal } from '@ui/stepper/steps/preventivo/modals/documentazione.modal.tsx'
import ServiziSuccess from '@ui/richiesta/pages/components/servizi/modals/success.component'
import ServiziError from '@ui/richiesta/pages/components/servizi/modals/error.component'
import IDLicense from '@ui/richiesta/pages/datiAnagrafici/modals/id-license.component'
import { scrollToTop } from '@utils/iframe'
//import { ExpiredSession } from '@ui/stepper/steps/richiesta/components/modal-views/expired-session.component'
import { UploadModalThanks } from '@ui/richiesta/pages/thank-you/components/upload.modal'
import { useSetAtom } from 'jotai'
import { modalShowHeader } from './atoms'
//import { forceScrollHeight } from '@hooks/use-resize.ts'
import { FileUploadComponent } from '@ui/richiesta/pages/components/modal-views/file-upload.component'
import { QRScanComponent } from '@ui/richiesta/pages/components/modal-views/mobile-upload.component'
import { ExpiredSession } from '@ui/richiesta/pages/components/modal-views/expired-session.component'
import { DocumentazioneModal } from '@ui/richiesta/pages/components/modals/documentazione.modal'
//import Modal from '@ui/components/Modal'
import { forceScrollHeight } from '@hooks/use-resize'
import Modal from '@ui/components/Modal'

type Modals =
	| 'Richiesta_CODICE-FISCALE'
	| 'Richiesta_CARTA-ID'
	| 'Richiesta_VERIFICA'
	| 'Richiesta_MOBILE'
	| 'Richiesta_EXPIRED'
	| 'Preventivo_DOCS'
	| 'Servizi_SUCCESS'
	| 'Servizi_ERROR'
	| 'Anagrafica_IDLICENSE'
	| 'Anagrafica_DRIVERLICENSE'
	| 'Thanks_CODICE-FISCALE'
	| 'Thanks_CARTA-ID'
	| 'Thanks_UNICO'
	| 'Thanks_ERROR'
	| 'Thanks_DOCS'
	| 'DEFAULT'

type ModalRecordBody = {
	body: () => JSX.Element
	nextStep?: Modals
	previousStep?: Modals
}

const ModalComponents: Record<Modals, ModalRecordBody> = {
	Richiesta_MOBILE: {
		body: () => <QRScanComponent />,
	},
	'Richiesta_CODICE-FISCALE': {
		body: () => (
			<FileUploadComponent title={'Codice fiscale'} id={'CF'} minDocs={1} />
		),
		nextStep: 'Richiesta_VERIFICA',
		previousStep: 'Richiesta_CARTA-ID',
	},
	'Richiesta_CARTA-ID': {
		body: () => (
			<FileUploadComponent
				title={'Carta di identità (cartacea o elettronica) o patente'}
				id={'IDE'}
				minDocs={1}
			/>
		),
		nextStep: 'Richiesta_CODICE-FISCALE',
	},
	/* Richiesta_VERIFICA: {
		body: () => <ModalSummaryComponent />,
		previousStep: 'Richiesta_CODICE-FISCALE',
	}, */
	Richiesta_EXPIRED: {
		body: () => <ExpiredSession />,
	},
	Preventivo_DOCS: {
		body: () => <DocumentazioneModal />,
	},
	Servizi_SUCCESS: {
		body: () => <ServiziSuccess />,
	},
	Servizi_ERROR: {
		body: () => <ServiziError />,
	},
	Anagrafica_IDLICENSE: {
		body: () => <IDLicense />,
	},
	Anagrafica_DRIVERLICENSE: {
		body: () => <IDLicense driverLicense />,
	},
	DEFAULT: {
		body: () => <p>Default view, nessuna modal specificata</p>,
	},
	Thanks_ERROR: {
		body: () => <p>si è verificato un errore con l'invio dei dati</p>,
	},
	'Thanks_CARTA-ID': {
		body: () => (
			<FileUploadComponent
				title={'Carta di identità (cartacea o elettronica) o patente'}
				id={'IDE'}
			/>
		),
		nextStep: 'Thanks_CODICE-FISCALE',
	},
	'Thanks_CODICE-FISCALE': {
		body: () => <FileUploadComponent title={'Codice fiscale'} id={'CF'} />,
		nextStep: 'Thanks_UNICO',
		previousStep: 'Thanks_CARTA-ID',
	},
	Thanks_DOCS: {
		body: () => <UploadModalThanks />,
	},
	Thanks_UNICO: {
		body: () => (
			<FileUploadComponent
				title={'Certificazione Unica'}
				id={'ALTRO'}
				minDocs={1}
				maxDocs={100}
			/>
		),
		//previousStep: 'Richiesta_CODICE-FISCALE',
	},
}

type ModalActions = 'NEXT' | 'PREVIOUS'

type ModalContextProviderProps = {
	children: React.ReactNode
	currentModal: Modals | null
} & OverlayTriggerProps

const ModalContextProvider: React.FC<ModalContextProviderProps> = ({
	children,
	currentModal,
	...props
}) => {
	const state = useOverlayTriggerState(props)
	const { dispatch, state: appState } = useAppContext()
	// forceScrollHeight()

	const currentSelectedModal = ModalComponents[currentModal ?? 'DEFAULT']
	const setHeaderDefault = useSetAtom(modalShowHeader)

	const ModalBody = currentSelectedModal.body

	const { overlayProps } = useOverlayTrigger({ type: 'dialog' }, state)

	forceScrollHeight()

	const selectStep = (step: ModalActions) => {
		dispatch({
			type: Actions.ShowModal,
			payload:
				currentSelectedModal[step === 'NEXT' ? 'nextStep' : 'previousStep'] ??
				'DEFAULT',
		})

		setHeaderDefault(true)
	}

	useEffect(() => {
		if (state.isOpen) {
			setHeaderDefault(true)
			parent.postMessage({ event_id: 'showModal' }, '*')
		} else {
			dispatch({
				type: Actions.ShowModal,
				payload: 'DEFAULT',
			})
			parent.postMessage({ event_id: 'hideModal' }, '*')
		}

		scrollToTop()
	}, [state.isOpen])

	return (
		<ModalContext.Provider
			value={{ open: state.open, goTo: selectStep, close: state.close }}
		>
			{state.isOpen && (
				<Modal
					goBack={
						currentSelectedModal.previousStep
							? () => {
									if (
										appState.ui.modal === 'Richiesta_VERIFICA' &&
										appState.ui.isCIE
									) {
										return dispatch({
											type: Actions.ShowModal,
											payload: 'Richiesta_CARTA-ID',
										})
									}
									selectStep('PREVIOUS')
							  }
							: null
					}
					state={state}
					{...props}
					{...overlayProps}
				>
					<ModalBody />
				</Modal>
			)}
			{children}
		</ModalContext.Provider>
	)
}

export { ModalContextProvider, type Modals, type ModalActions }
